import React, { ReactElement } from 'react';
import { useLocation } from 'react-router';
import { Heading } from 'idsk-react-components';
import Layout from '../Layout';
import './addPripomienkaAdminPage.scss';
import ClassType from '../../model/pripomienka/ClassType';
import { AddPripomienkaAdmin } from '../../module/CreateAndUpdatePripomienkaAdmin';
import routes from '../../routing/routes';
import UserRole from '../../model/currentuser/UserRole';
import SecuredPage from '../../module/SecuredPage';

interface Props {
  classType: ClassType;
}

export default ({ classType }: Props): ReactElement => {
  const { pathname } = useLocation();

  return (
    <Layout
      isHromadna={classType === ClassType.HROMADNA_PRIPOMIENKA}
      breadcrumbRouteList={[{
        heading: classType === ClassType.HROMADNA_PRIPOMIENKA
          ? routes.admin.hromadnePripomienky.add.name
          : routes.admin.pripomienky.add.name,
        to: pathname,
      }]}
    >
      <SecuredPage
        allowForRoles={[UserRole.SUPERADMIN]}
      >
        <div className="add-pripomienka-admin-page">
          <Heading size="l">
            Nová {classType === ClassType.HROMADNA_PRIPOMIENKA && 'hromadná'} pripomienka (admin)
          </Heading>
          <AddPripomienkaAdmin
            classType={classType}
          />
        </div>
      </SecuredPage>
    </Layout>
  );
};
